import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(priceInCents: number, inventoryType?: string, currencyCode?: string): string {
  // Check if price is invalid or zero
  if (!priceInCents || priceInCents === 0) {
    return 'N/A';
  }
  
  const price = priceInCents / 100;

  // For digital inventory, show /spot format
  if (inventoryType === 'digital' || inventoryType === 'Digital') {
    return `${currencyCode} ${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/spot`;
  }

  // For classic/static inventory, show monthly rate format (price is already the monthly amount)
  if (inventoryType === 'static' || inventoryType === 'Classic') {
    return `${currencyCode} ${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}/month`;
  }

  // For package inventory, show fixed price format
  if (inventoryType === 'Package' || inventoryType === 'package') {
    return `${currencyCode} ${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} Fixed Price`;
  }

  // For other inventory types, show regular format
  return `${currencyCode} ${price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function generateSessionId(): string {
  return `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export function getSessionId(): string {
  let sessionId = localStorage.getItem('billboardhub_session_id');
  if (!sessionId) {
    sessionId = generateSessionId();
    localStorage.setItem('billboardhub_session_id', sessionId);
  }
  return sessionId;
}

export function getMediaOwner(mediaOwnerName: string): { id: string; name: string } | undefined {
  const mediaOwners: Record<string, { id: string; name: string }> = {
    "Clear Channel Outdoor": { id: "clear-channel", name: "Clear Channel Outdoor" },
    "JCDecaux": { id: "jcdecaux", name: "JCDecaux" },
    "Lamar Advertising": { id: "lamar", name: "Lamar Advertising" },
    "OUTFRONT Media": { id: "outfront", name: "OUTFRONT Media" },
    "Adams Outdoor Advertising": { id: "adams", name: "Adams Outdoor Advertising" },
    "Intersection Media": { id: "intersection", name: "Intersection Media" },
    "Reagan Outdoor Advertising": { id: "reagan", name: "Reagan Outdoor Advertising" },
    "AdVantage Media": { id: "advantage", name: "AdVantage Media" },
  };

  return mediaOwners[mediaOwnerName] || undefined;
}